import { Injectable } from '@angular/core'
import { SettingsService } from '@app/services/settings.service'
import { State, Action, StateContext, Selector } from '@ngxs/store'
import { SettingsAction } from './settings.actions'

export class SettingsStateModel {
  public bindOnlineEnabled!: boolean
  public allowDatesPast30Days!: boolean
  public modelLawEnabled!: boolean
  public stripeEnabled!: boolean
}

const defaults: SettingsStateModel = {
  bindOnlineEnabled: true,
  allowDatesPast30Days: false,
  modelLawEnabled: false,
  stripeEnabled: false,
}

@State<SettingsStateModel>({
  name: 'settings',
  defaults,
})
@Injectable()
export class SettingsState {
  constructor(private readonly settingsService: SettingsService) { }

  @Action(SettingsAction.Update)
  async update({ setState }: StateContext<SettingsStateModel>) {
    try {
      const settings = (await this.settingsService.getFeatureFlags()) as SettingsStateModel
      setState(settings)

      return
    } catch (err) {
      return Promise.reject(err)
    }
  }

  @Selector()
  static bindOnlineEnabled(state: SettingsStateModel) {
    return state.bindOnlineEnabled
  }

  @Selector()
  static allowStartDatePast30Days(state: SettingsStateModel) {
    return state.allowDatesPast30Days
  }

  @Selector()
  static modelLawEnabled(state: SettingsStateModel) {
    return state.modelLawEnabled
  }

  @Selector()
  static stripeEnabled(state: SettingsStateModel) {
    return state.stripeEnabled
  }
}
